import React, { useState, useEffect } from 'react';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import styles from './PaintingsGallery.module.css';

import Painting1 from '../../images/painting-2.jpg';
import Painting2 from '../../images/painting-3.jpg';
import Painting3 from '../../images/painting-5.jpg';
import Painting4 from '../../images/painting-6.jpg';
import Painting5 from '../../images/painting-4.jpg';
import Painting6 from '../../images/painting-8.jpg';
import Painting7 from '../../images/painting-9.jpg';
import Painting8 from '../../images/painting-7.jpg';

const PortfolioGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const images = [
    { id: 1, url: Painting1 },
    { id: 2, url: Painting2 },
    { id: 3, url: Painting3 },
    { id: 4, url: Painting4 },
    { id: 5, url: Painting5 },
    { id: 6, url: Painting6 },
    { id: 7, url: Painting7 },
    { id: 8, url: Painting8 },
  ];

  return (
    <div className={styles.pageWrapper}>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />

      <div className={styles.portfolioContainer}>
        <div className={styles.animatedBackground}>
          <div className={`${styles.gradientOrb} ${styles.orb1}`}></div>
          <div className={`${styles.gradientOrb} ${styles.orb2}`}></div>
          <div className={`${styles.gradientOrb} ${styles.orb3}`}></div>
        </div>

        <div className={styles.contentWrapper}>
          <h1 className={styles.galleryTitle}>Paintings</h1>
          <div className={styles.titleDecoration} />

          <div className={styles.descriptionSection}>
            <p className={styles.descriptionText}>
              During breaks, indulge in my favorite hobby : creating scribble art, a form I deeply enjoy. With a passion for drawing and a keen interest in painting, I explore creativity and relaxation during work intervals.
            </p>
          </div>

          <div className={styles.galleryGrid}>
            {images.map((image) => (
              <div
                key={image.id}
                className={styles.galleryItem}
                onClick={() => setSelectedImage(image)}
              >
                <div className={styles.imageWrapper}>
                  <img src={image.url} alt={`Painting ${image.id}`} className={styles.galleryImage} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {selectedImage && (
          <div className={styles.modalOverlay} onClick={() => setSelectedImage(null)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <button className={styles.closeBtn} onClick={() => setSelectedImage(null)}>
                ×
              </button>
              <img
                src={selectedImage.url}
                alt={`Painting ${selectedImage.id}`}
                className={styles.modalImage}
              />
            </div>
          </div>
        )}
      </div>

      <div className={styles.footerOverride}>
        <Footer mode={mode} />
      </div>
    </div>
  );
};

export default PortfolioGallery;